import { render, staticRenderFns } from "./SliderModal.vue?vue&type=template&id=6a95d1f1"
import script from "./SliderModal.vue?vue&type=script&lang=js"
export * from "./SliderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports